export default {"src":"/_next/static/media/payment_accepted.0ca7a7b7.gif","height":1080,"width":1920,"blurWidth":0,"blurHeight":0};